export default "__VITE_ASSET__8416c1e0__"